import { c as _c } from "react/compiler-runtime";
import { ButtonLink } from '@sbt-web/ui';
import styles from './index.module.scss';
export const GoToShop = t0 => {
  const $ = _c(3);
  const {
    url
  } = t0;
  if (!url) {
    return;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [styles.link];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== url) {
    t2 = <ButtonLink href={url} design="outline" classes={t1}>Vai allo shop</ButtonLink>;
    $[1] = url;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};